/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// You can delete this file if you're not using it

exports.onClientEntry = () => {
  const PB = {
    ABN: '32 667 416 079',
  }

  window.PB = Object.freeze(PB)
}
